export default value => {
    return value === true;
};



// WEBPACK FOOTER //
// ./resources/assets/js/validators/mustBeTrue.js